import { ID } from '@datorama/akita';
export interface AccountIssuer {
    accountIssuerCountryCode: string;
    accountIssuerCredentialsAddressLine1: string;
    accountIssuerCredentialsAddressLine2: string;
    accountIssuerCredentialsAddressLine3: string;
    accountIssuerCredentialsEmail: string;
    accountIssuerCredentialsFax: string;
    accountIssuerCredentialsPhone1: string;
    accountIssuerCredentialsPhone2: string;
    accountIssuerId: number;
    accountIssuerLeiCode: string;
    accountIssuerLongName: string;
    accountIssuerShortName: string;
    accountIssuerVersion: number;
    correlationId: ID;
    parentAccountIssuerId?: ID;
    status?: AccountIssuerStatus;
    displayName: string;
    metadata: {
        logoUrl: string;
        website: string;
        countryCode: string;
    };
}

export enum AccountIssuerStatus {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    ALL = '' // used as initial value (ALL)
}

export function createAccountIssuer(params: Partial<AccountIssuer>) {
    return {} as AccountIssuer;
}
